// Reusable step fragments for guide scenarios. A step is plain data, so reuse
// is composition: import a factory/constant and spread it into a walkthrough's steps.
// Keep copy in the locale files (steps carry `bodyKey`s, never literal text) so
// a shared step doesn't couple two flows' wording — when the wording must
// differ, use a factory and pass the `bodyKey`.
import type { GuideWalkthroughStepDef } from "../../types";

/** The transport list route (`positions` page). */
export const TRANSPORT_LIST_ROUTE = "/recap_transport";

/**
 * An EXPLAIN step on the transport LIST: spotlight a control and advance on the
 * caption's "Suivant"/"Terminé" button — the user reads, needn't operate it.
 * `routeExact` keeps it list-only (an open order is a child path).
 */
export function explainListStep(
  target: string,
  bodyKey: string,
): GuideWalkthroughStepDef {
  return {
    route: TRANSPORT_LIST_ROUTE,
    routeExact: true,
    target,
    bodyKey,
    advanceOn: "next",
  };
}

/**
 * An EXPLAIN step INSIDE an open order (the focus page). Unlike
 * `explainListStep`, the route is a PREFIX (no `routeExact`) — the focus path
 * `/recap_transport/:id` is a child of the list route, so an open order still
 * counts as on-route. Pass `optional` for a control that is legitimately
 * conditional (a tenant-configurable custom field/column, a line-scoped control
 * on a zero-line order): the overlay then SKIPS the step when its target never
 * appears instead of ending on a drift error.
 */
export function explainFocusStep(
  target: string,
  bodyKey: string,
  opts?: { optional?: boolean },
): GuideWalkthroughStepDef {
  return {
    route: TRANSPORT_LIST_ROUTE,
    target,
    bodyKey,
    advanceOn: "next",
    ...(opts?.optional ? { optional: true } : {}),
  };
}
